import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { CheckCircle, Phone, Home } from 'lucide-react';

export const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0B1020] flex items-center justify-center px-4 py-12">
      <Card className="max-w-2xl w-full bg-[#121A2B] border-[#1E293B] p-8 sm:p-12 text-center">
        <div className="w-20 h-20 rounded-full bg-[#22C55E]/20 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="text-[#22C55E]" size={48} />
        </div>
        
        <h1 className="text-4xl sm:text-5xl font-bold text-[#F8FAFC] mb-4">
          You're In.
        </h1>
        
        <p className="text-xl text-[#94A3B8] mb-8">
          Your info has been received. Bryan will reach out shortly with next steps.
        </p>

        <div className="bg-[#0B1020] border border-[#1E293B] rounded-lg p-6 mb-8">
          <p className="text-[#F8FAFC] mb-4">
            Need to talk right now?
          </p>
          <a 
            href="sms:801-651-8363" 
            className="inline-block"
          >
            <Button className="bg-[#3B82F6] hover:bg-[#2563EB] text-white text-lg px-8 py-6 h-auto">
              <Phone className="mr-2" size={20} />
              Text: 801-651-8363
            </Button>
          </a>
        </div>

        <div className="space-y-4">
          <p className="text-sm text-[#94A3B8]">
            You can also reach Bryan at:
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:801-651-8363" 
              className="text-[#3B82F6] hover:text-[#2563EB] transition-colors font-semibold"
            >
              Call: 801-651-8363
            </a>
            <span className="text-[#94A3B8] hidden sm:block">|</span>
            <a 
              href="mailto:Bryan@DirectMeds.com" 
              className="text-[#3B82F6] hover:text-[#2563EB] transition-colors font-semibold"
            >
              Bryan@DirectMeds.com
            </a>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-[#1E293B]">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="border-[#1E293B] bg-transparent hover:bg-[#1E293B] text-[#F8FAFC]"
          >
            <Home className="mr-2" size={18} />
            Return to Home
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default ThankYou;
